import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { ServiceInfos, doGetCardReaderInfos } from '../thunks/cardReadThunk'

export enum CardType {
  CPS = 'CPS',
  CPE = 'CPE',
  VITALE = 'CV',
}

export interface CPSCard {
  type: 'CPS'
  firstName: string
  lastName: string
  RPPS: string
}

export interface CPECard {
  type: 'CPE'
  firstName: string
  lastName: string
  organisation: string
}

export interface VitaleCard {
  type: 'CV'
  firstName?: string
  lastName?: string
  dateOfBirth?: string
}

export type InsertedCard = CPSCard | CPECard | VitaleCard

interface AppState {
  cardReaderState: ServiceInfos
  printerState?: ServiceInfos
  scannerState?: ServiceInfos
  cardReaderInsertedCards: InsertedCard[]
}

const initialState: AppState = {
  cardReaderState: {
    id: '',
    status: 0,
    statusDescription: 'DISCONNECTED',
  },
  cardReaderInsertedCards: [],
}

const appStateSlice = createSlice({
  name: 'app',
  initialState,
  reducers: {
    setReaderState: (state, action: PayloadAction<ServiceInfos>) => {
      state.cardReaderState = action.payload
    },
    setPrinterState: (state, action: PayloadAction<ServiceInfos>) => {
      state.printerState = action.payload
    },
    setScannerState: (state, action: PayloadAction<ServiceInfos>) => {
      state.scannerState = action.payload
    },
    setInsertedCards: (state, action: PayloadAction<InsertedCard[]>) => {
      state.cardReaderInsertedCards = action.payload
    },
    addOrUpdateInsertedCard: (state, action: PayloadAction<InsertedCard>) => {
      const cardIndex = state.cardReaderInsertedCards.findIndex(
        (card) => card.type === action.payload.type,
      )
      if (cardIndex >= 0) {
        state.cardReaderInsertedCards[cardIndex] = action.payload
      } else {
        state.cardReaderInsertedCards.push(action.payload)
      }
    },
    removeInsertedCard: (state, action: PayloadAction<CardType>) => {
      state.cardReaderInsertedCards = state.cardReaderInsertedCards.filter(
        (card) => card.type !== action.payload,
      )
    },
  },
  extraReducers(builder) {
    builder.addCase(doGetCardReaderInfos.fulfilled, (state, action) => {
      state.cardReaderState = action.payload
    })
  },
})

export const {
  setReaderState,
  setPrinterState,
  setScannerState,
  setInsertedCards,
  addOrUpdateInsertedCard,
  removeInsertedCard,
} = appStateSlice.actions

export default appStateSlice.reducer
